var render, staticRenderFns
import script from "./ResultChart.vue?vue&type=script&lang=js&"
export * from "./ResultChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4c1a94",
  null
  
)

export default component.exports